module.exports = __webpack_public_path__ + "img/lifecycle2.6f2c97f0.png";